<template>
  <v-dialog v-model="statisticUserDialog" width="1200">
    <v-card>
      <!--Country and closebar-->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <p class="pr-5 text--primary display-1 pt-5" v-if="item.country !== 'null'">
          {{item.country}}
        </p>
        <p class="pr-5 text--primary display-1 pt-5" v-else>
          Country not specified: {{item.country}}
        </p>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="ma-0 pa-0 pt-3">
          <v-col md="12">
            <v-hover>
              <v-card text height="100%" elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`" class="ma-0 pa-0">
                <v-card-text class="ma-0 pa-0">
                  <!--Total stats-->
                  <v-row class="ma-0 pa-0 pb-2">
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0">
                        <span class="ma-0 pa-0 pb-2">Users:</span>
                        <span class="display-1 font-weight-bold pl-1">{{item.users}}</span>
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0">
                        <span class="ma-0 pa-0 pb-2">Active users</span>
                        <span class="display-1 font-weight-bold pl-1">{{item.ActiveUsersTotal}}</span>
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0">
                        <span class="ma-0 pa-0 pb-2">Inactive users</span>
                        <span class="display-1 font-weight-bold pl-1">{{item.InactiveUsersTotal}}</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <v-row class="ma-0 pa-0 pt-2">
                    <!--Stats today-->
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0 pb-2">Today</p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>New users:</span>
                        <span class="font-weight-bold pl-1">{{item.newUsersDay}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Active users:</span>
                        <span class="font-weight-bold pl-1">{{item.ActiveUsersDay}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Inactive users:</span>
                        <span class="font-weight-bold pl-1">{{item.InactiveUsersDay}}</span>
                      </p>
                    </v-col>
                    <!--Stats this week-->
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0 pb-2">This week</p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>New users:</span>
                        <span class="font-weight-bold pl-1">{{item.newUsersWeek}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Active users:</span>
                        <span class="font-weight-bold pl-1">{{item.ActiveUsersWeek}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Inactive users</span>
                        <span class="font-weight-bold pl-1">{{item.InactiveUsersWeek}}</span>
                      </p>
                    </v-col>
                    <!--Stats this Month-->
                    <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0 pb-2">This Month</p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>New users:</span>
                        <span class="font-weight-bold pl-1">{{item.newUsersMonth}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Active users:</span>
                        <span class="font-weight-bold pl-1">{{item.ActiveUsersMonth}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Inactive users:</span>
                        <span class="font-weight-bold pl-1">{{item.InactiveUsersMonth}}</span>
                      </p>
                    </v-col>
                    <!--Stats this year-->
                     <v-col class="ma-0 pa-0">
                      <p class="title ma-0 pa-0 pb-2">This Year</p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>New users:</span>
                        <span class="font-weight-bold pl-1">{{item.newUsersYear}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Active users</span>
                        <span class="font-weight-bold pl-1">{{item.ActiveUsersYear}}</span>
                      </p>
                      <p class="subtitle-1 ma-0 pa-0">
                        <span>Inactive users</span>
                        <span class="font-weight-bold pl-1">{{item.InactiveUsersYear}}</span>
                      </p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <!--Tabs and simple graphs-->
        <v-row class="ma-0 pa-0">
          <v-col class="ma-0 pa-0">
            <v-tabs>
              <v-tab>New Users</v-tab>
              <v-tab>Active Users</v-tab>
              <v-tab>Inactive Users</v-tab>
              <v-tab>Banned Users</v-tab>
              <!--Display New users within a year-->
              <v-tab-item class="pt-3">
                <v-card class="mx-auto text-center" color="blue lighten-3"  max-width="600">
                  <v-card-text>
                    <p class="display-1">
                      <span>Total Users: </span>
                      <span class="font-weight-bold pl-3">{{item.users}}</span>
                    </p>
                    <v-sheet color="blue lighten-4">
                      <!-- :labels="labels" -->
                      <v-sparkline :value="item.NewUserYearGraph" color="red" height="100" padding="24" stroke-linecap="round" smooth>
                        
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>
                  <v-card-text class="ma-0 pa-0">
                    <p class="title font-weight-bold">
                      <span>Total new users this year:</span>
                      <span>{{item.newUsersYear}}</span>
                    </p>
                    <v-row class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>New users (24h):</span>
                          <span class="font-weight-bold">{{item.newUsersDay}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>New users (Week):</span>
                          <span class="font-weight-bold">{{item.newUsersWeek}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>New users (Month):</span>
                          <span class="font-weight-bold">{{item.newUsersMonth}}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              
              <!--Display Active Users-->
              <v-tab-item class="pt-3">
                <v-card class="mx-auto text-center" color="green lighten-3"  max-width="600">
                  <v-card-text>
                    <p class="title ">
                      <span>Total active users this week:</span>
                      <span class="font-weight-bold pl-3">{{item.ActiveUsersWeek}}</span>
                    </p>
                    <v-sheet color="green lighten-4">
                      <v-sparkline :value="item.ActiveUserYearGraph" color="red" height="100" padding="24" stroke-linecap="round" smooth>
                        <template v-slot:label="item">
                          {{ item.value }}
                        </template>
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>
                  <v-card-text class="ma-0 pa-0">
                    <p class="display-1 font-weight-bold">
                      <span>Total active users:</span>
                      <span>{{item.ActiveUsersTotal}}</span>
                    </p>
                    <v-row class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Active users (24h):</span>
                          <span class="font-weight-bold">{{item.ActiveUsersDay}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Active users (Week):</span>
                          <span class="font-weight-bold">{{item.ActiveUsersWeek}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Active users (Month):</span>
                          <span class="font-weight-bold">{{item.ActiveUsersMonth}}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
  
              <!--Display Inactive Users-->
              <v-tab-item class="pt-3">
                <v-card class="mx-auto text-center" color="yellow lighten-2"  max-width="600">
                  <v-card-text>
                    <p class="title ">
                      <span>Total Inactive users this week:</span>
                      <span class="font-weight-bold pl-3">{{item.InactiveUsersWeek}}</span>
                    </p>
                    <v-sheet color="yellow lighten-3">
                      <v-sparkline :value="item.InactiveUsersYearGraph" color="red" height="100" padding="24" stroke-linecap="round" smooth>
                        <template v-slot:label="item">
                          {{ item.value }}
                        </template>
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>
                  <v-card-text class="ma-0 pa-0">
                    <p class="display-1 font-weight-bold">
                      <span>Total Inactive users:</span>
                      <span>{{item.InactiveUsersTotal}}</span>
                    </p>
                    <v-row class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Inactive users (24h):</span>
                          <span class="font-weight-bold">{{item.InactiveUsersDay}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Inactive users (Week):</span>
                          <span class="font-weight-bold">{{item.InactiveUsersWeek}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Inactive users (Month):</span>
                          <span class="font-weight-bold">{{item.InactiveUsersMonth}}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <!--Display Banned Users-->
              <v-tab-item class="pt-3">
                <v-card class="mx-auto " color="red lighten-2"  max-width="600">
                  <v-card-text>
                    <p class="title ">
                      <span>Total Banned users this week:</span>
                      <span class="font-weight-bold pl-3">{{item.BannedUsersWeek}}</span>
                    </p>
                    <v-sheet color="red lighten-3">
                      <v-sparkline :value="item.BannedUsersYearGraph" color="red lighten-3" height="100" padding="24" stroke-linecap="round" smooth>
                        <template v-slot:label="item">
                          {{ item.value }}
                        </template>
                      </v-sparkline>
                    </v-sheet>
                  </v-card-text>
                  <v-card-text class="ma-0 pa-0">
                    <p class="display-1 font-weight-bold">
                      <span>Total Banned users:</span>
                      <span>{{item.BannedUsersTotal}}</span>
                    </p>
                    <v-row class="ma-0 pa-0">
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Banned users (24h):</span>
                          <span class="font-weight-bold">{{item.BannedUsersDay}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Banned users (Week):</span>
                          <span class="font-weight-bold">{{item.BannedUsersWeek}}</span>
                        </p>
                      </v-col>
                      <v-col class="ma-0 pa-0">
                        <p class="subtitle-1">
                          <span>Banned users (Month):</span>
                          <span class="font-weight-bold">{{item.BannedUsersMonth}}</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import StatisticNewUsersGraph from "@/pages/admin/components/statistic/users/graph/statisticNewUsersGraph"
export default {
  components:{
    StatisticNewUsersGraph
  },
  data(){
    return{
      // Define the dialog v-model that we are using
      statisticUserDialog:false,
      item: {},
      labels: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
      ],
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog(item) {
      this.item = item;
      this.statisticUserDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.statisticUserDialog = false;
    }
  }
}
</script>